import { useEffect, useState } from "react";
import {
  commaDigits,
  complexDigitToman,
  convertCurrencyToRial,
  convertCurrencyToToman,
  convertToJalaliWithoutTime,
  regexFormater,
  validateInput,
} from "../../../tools/tools";

import styles from "./Withdraw.module.scss";
import { Form, Col, Row, Input, Tooltip, Button, Divider, Modal } from "antd";
import { InfoCircleOutlined } from "@ant-design/icons";
import { useSelector } from "react-redux";
import { useAPIPublic } from "../../../tools/api";
import Loading from "../../../components/loader/loading";
import { useTranslation } from "react-i18next";
import Layouts from "../../layout/layouts";
import { ModalFactorWithdraw } from "../../landing/details/modal/policyModal";
const Withdraw = () => {
  const [t] = useTranslation("global");

  const { queryMinimumAmountGetCashFromWallet, withdrawUserWallet } = useAPIPublic();

  const [frmWithdraw] = Form.useForm();
  const { _currentUser } = useSelector((state) => state?.another);

  const [minimumAmount, setMinimumAmount] = useState(0);

  const [acceptForPayment, setAcceptForPayment] = useState(false);
  const [priceForPayment, setPriceForPayment] = useState(0);

  const [loading, setLoading] = useState(false);

  const [isOpenModal, setIsOpenModal] = useState(false);
  const [factorForDraw, setFactorForDraw] = useState({});

  useEffect(() => {
    const initialGetService = async () => {
      setLoading(true);
      let response = await queryMinimumAmountGetCashFromWallet();
      setMinimumAmount(response);
      frmWithdraw.setFieldValue("bankaccountnumber", _currentUser?.bankaccountnumber);
      setLoading(false);
    };
    initialGetService();
    frmWithdraw.setFieldValue("sheba", _currentUser?.shebanumber);
  }, []);

  const handleComma = (e) => {
    let v = e.target.value;
    if (e.target.value.length > 0 && !isNaN(parseInt(e.target.value))) {
      v = commaDigits(parseInt(e.target.value.replace(/,/g, "")) / 1);
      e.target.value = v;
      return v;
    } else {
      return "";
    }
  };
  const handleSubmit = async (values) => {
    try {
      setLoading(true);
      if (acceptForPayment) {
        let payload = {
          amount: priceForPayment,
          planid: process.env.REACT_APP_WITHDRAW_PLANID,
        };
        let response = await withdrawUserWallet(payload);
        if (response) {
          setAcceptForPayment(false);
          setFactorForDraw(response);
          setIsOpenModal(true);
        }
      } else {
        setPriceForPayment(convertCurrencyToRial(regexFormater(values.amount).removeComma()));
        setAcceptForPayment(true);
      }
      setLoading(false);
    } catch (error) {}
  };
  return (
    <>
      <div className={styles.Withdraw}>
        <div className={styles.title}>
          <h3>درخواست استرداد وجه</h3>
        </div>
        <div className={styles.holder_form}>
          <Form form={frmWithdraw} id="frmWithdraw" layout="vertical" onFinish={handleSubmit}>
            <Row gutter={30}>
              <Col xxl={8} xl={12} lg={12} sm={12} xs={24}>
                <Form.Item
                  name="amount"
                  label="مبلغ (تومان)"
                  rules={[
                    validateInput({
                      t: t,
                      validate: true,
                      type: "chargeWallet",
                      priceAmount: convertCurrencyToToman(minimumAmount),
                    }),
                  ]}
                  extra={
                    <>
                      <p className={styles.extra_input}>
                        <Tooltip title={`حداقل مانده کیف پول میبایست ${complexDigitToman(minimumAmount)} هزار تومان باشد`}>
                          <InfoCircleOutlined />
                        </Tooltip>
                        <span style={{ marginRight: ".5rem" }}>
                          مبلغ قابل برداشت:{" "}
                          <span dir="ltr">
                            {complexDigitToman(_currentUser?.walletAmount - minimumAmount < 0 ? 0 : _currentUser?.walletAmount - minimumAmount)}
                          </span>{" "}
                          تومان{" "}
                        </span>
                      </p>
                    </>
                  }
                >
                  <Input
                    disabled={acceptForPayment ? true : false}
                    onInput={handleComma}
                    onPaste={(e) => e.preventDefault()}
                    maxLength="10"
                    dir="ltr"
                    autoComplete="off"
                    suffix={
                      <>
                        {!acceptForPayment && (
                          <span
                            onClick={() => {
                              frmWithdraw.setFieldValue("amount", complexDigitToman(_currentUser?.walletAmount - minimumAmount));
                            }}
                            className={styles.totalAmount}
                          >
                            کل موجودی
                          </span>
                        )}
                      </>
                    }
                    placeholder="مبلغ را وارد کنید"
                  />
                </Form.Item>
              </Col>
              <Col xxl={8} xl={12} lg={12} sm={12} xs={24}>
                <Form.Item name="sheba" label={<>شماره شبا</>}>
                  <Input dir="ltr" disabled />
                </Form.Item>
              </Col>
            </Row>
            {acceptForPayment && (
              <div className="holder-withDrawal-price">
                <p>
                  درخواست عودت مبلغ ودیعه با موفقیت ثبت شد. در صورت تایید درخواست توسط آپتل، مبلغ{" "}
                  <span className="result-sucess">{complexDigitToman(priceForPayment)}</span> تومان طی حداکثر 7 روزکاری به شماره شبای اعلام شده واریز
                  خواهد شد.
                </p>
              </div>
            )}
            <div className="holder-button">
              <Button id="frmWithdraw" key={frmWithdraw} htmlType="submit" className="btn-aptel">
                درخواست استرداد
              </Button>
            </div>
          </Form>
        </div>
        <div className={styles.holder_notes}>
          <Divider />
          <ul>
            <li>
              <svg xmlns="http://www.w3.org/2000/svg" width="8" height="7" viewBox="0 0 8 7" fill="none">
                <ellipse cx="4.34506" cy="3.5" rx="3.65756" ry="3.5" fill="#E64225" />
              </svg>
              <span style={{ marginRight: ".5rem" }}>
                در صورتی که برنده مزایده شده باشید و از پرداخت ما به تفاوت مبلغ نهایی و ودیعه امتناع نمایید، مبلغ ودیعه شما نزد آپتل ضبط خواهد گردید.
              </span>
            </li>
          </ul>
        </div>
      </div>
      <Loading isOpen={loading} />
      <ModalFactorWithdraw
        factor={factorForDraw}
        open={isOpenModal}
        callback={(e) => {
          setIsOpenModal(false);
        }}
      />
    </>
  );
};

export default Withdraw;
